import error from "@/router/pages/common/error";

const ErrorLayout = () => import(/* webpackChunkName: "error" */ "@/layouts/error");

const errorLayout = [
  {
    path: "/",
    name: "ErrorLayout",
    component: ErrorLayout,
    children: [...error],
  },
];

export default errorLayout;
